import { useMemo } from 'react';

import { useSpotlight } from '../../../queries/employee-spotlights';
import { EmployeeSpotlightSection } from '../../../schemas/spotlight';

type UseEmployeeSpotlightSelectedSectionArgs = {
	spotlightId: string;
	sectionId?: string;
	enabled?: boolean;
};

type UseEmployeeSpotlightSelectedSectionResult = {
	isLoading: boolean;
	spotlight?: { sections: EmployeeSpotlightSection[] } | undefined;
	selectedSection: EmployeeSpotlightSection | undefined;
};

export const useEmployeeSpotlightSelectedSection = ({
	spotlightId,
	sectionId,
	enabled,
}: UseEmployeeSpotlightSelectedSectionArgs): UseEmployeeSpotlightSelectedSectionResult => {
	const { data: spotlight, isInitialLoading } = useSpotlight(spotlightId, { enabled });

	const selectedSection = useMemo(() => {
		const sections = spotlight?.sections ?? [];
		if (sections.length === 0) return undefined;

		return (sectionId ? sections.find((section) => section.id === sectionId) : undefined) ?? sections[0];
	}, [spotlight?.sections, sectionId]);

	return {
		isLoading: isInitialLoading,
		spotlight: spotlight ? { sections: spotlight.sections } : undefined,
		selectedSection,
	};
};
